import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { AdmissionInsuranceData, AdmissionInsurance } from '../../../interfaces/Ip/admissioInsurancee';
import { AdmissionInsuranceApi } from '../api/admissionInsurance.api';

@Injectable() 
export class AdmissionInsuranceService extends AdmissionInsuranceData{
 
  constructor(private api: AdmissionInsuranceApi) {
    super();
  } 
  
  getall(url: string): Observable<AdmissionInsurance[]> { 
    return this.api.getall(url);
  } 

  getById(url:string): Observable<AdmissionInsurance>{
    return this.api.getById(url);
    }

  create(url: string, data:AdmissionInsurance): Observable<AdmissionInsurance[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:AdmissionInsurance): Observable<AdmissionInsurance> { 
    return this.api.update(url,data);
  }  

  list(url: string): Observable<any> {
    return this.api.list(url);
  }
}
